<template>
	<div>
		<breadcrumb :list="breadcrumbList"></breadcrumb>
		<el-card class="main">
			<div class="subject">
				<el-row type="flex" class="subject_title">
					<img src="@/assets/img/tag.png" alt="">
					<span class="title_text">检查信息</span>
				</el-row>

				<el-descriptions class="margin-top" border labelClassName="labelWidth" contentClassName="contentWidth"
					:column="3">
					<el-descriptions-item label="登记序号">{{ list.rcjcdjxh }}</el-descriptions-item>
					<el-descriptions-item label="所属场所">{{ list.csmc }}</el-descriptions-item>
					<el-descriptions-item label="检查机构">{{ list.jcjg }}</el-descriptions-item>
					<!--  -->
					<el-descriptions-item label="检查人员"> {{ list.jcr_xm }}</el-descriptions-item>
					<el-descriptions-item label="职务"> {{ list.jcr_zw }}</el-descriptions-item>
					<el-descriptions-item label="检查日期"> {{ list.jcrq | formatDate }}</el-descriptions-item>
					<!--  -->
					<el-descriptions-item label="场所负责人"> {{ list.csfzr_xm }}</el-descriptions-item>
					<el-descriptions-item label="检查类型"> {{ list.jclxbm }}</el-descriptions-item>
					<el-descriptions-item label="是否合格"> {{ list.jchg | sfFilter }}</el-descriptions-item>
					<el-descriptions-item label="发现问题"> {{ list.csjc_jyqk }}</el-descriptions-item>
					<!--  -->
					<el-descriptions-item label="处理结果"> {{ list.cljg_jyqk }}</el-descriptions-item>
					<el-descriptions-item label="备注" :span="2"> {{ list.jcbz }}</el-descriptions-item>
					<!--  -->
					<el-descriptions-item label="检查照片" :span="3">
						<el-image v-for="item in imgList" :key="item" fit="contain" style="width: 200px; height: 100px;padding: 5px;"
							:src="item" :preview-src-list="imgList" />
					</el-descriptions-item>
				</el-descriptions>


			</div>
			<div class="subject_btn" style="text-align:center;margin-top: 56px;">
				<!-- <el-button type="info" @click="goBack">返回</el-button>  2020-06-02 产品去掉-->
				<el-button type="primary" @click="$router.back(-1)" class="go_back">返回</el-button>
			</div>
		</el-card>
	</div>
</template>

<script>
import { getDaliyItem } from '@/api/day_work.js'
import { lists, filtersInfo } from '@/utils/dictionary.js'
import { getJCLX } from '@/api/day_work'

import { formatDate } from '@/utils'
let that
export default {
	name: 'DetailsDailyInspectionVue',
	data() {
		return {
			breadcrumbList: [
				{ name: "公安机关日常检查", path: "daily_inspect" },
				{ name: "详情", path: "daily_inspect/daily_inspect_details" }
			],
			list: [],
			sfList: [],
			jcjgList: [],
			jclxbmList: [],
			imgList: [],
			loading: true
		}
	},
	beforeCreate() {
		that = this
	},
	created() {
		this.info()
	},
	methods: {
		async info() {
			this.id = this.$route.query.id
			this.list = await getDaliyItem(this.id)
			this.sfList = lists['SF']
			this.jcjgList = lists['LCLX']
			this.jclxbmList = await getJCLX()
			if (this.list.jczp) {
				this.imgList = this.list.jczp.split(',')
			}
			console.log(this.imgList);
		}
	},
	filters: {
		sfFilter(val) {
			if (!val && val != 0) return
			return filtersInfo(that.sfList, val)
		},
		jclxbmFilter(val) {
			if (!val && val != 0) return
			return filtersInfo(that.jclxbmList, val)
		},
		formatDate(val) {
			if (!val && val != 0) return
			return formatDate(val)
		},
	}
}
</script>

<style lang="less" scoped>
.main {
	margin: 20px;
	padding: 22px 20px;

	.subject {
		.subject_title {
			margin-bottom: 23px;

			img {
				width: 30px;
				height: 39px;
				margin-right: 3px;
			}

			.title_text {
				font-size: 18px;
				line-height: 36px;
				font-family: Source Han Sans SC;
				font-weight: bold;
				color: #6345D5;
			}
		}
	}

	/deep/ .labelWidth {
		width: 150px;
	}

	/deep/ .contentWidth {
		width: 18vw;
	}

	.go_back {
		width: 80px;
		height: 50px;
		background: #FFFFFF;
		border: 1px solid #6345D5;
		border-radius: 6px;
		color: #6345D5;
	}
}
</style>
